<template>
    <canvas
        ref="chart"
        @click="$emit('open-editor', this.highlighted)"
        @mousemove="trackMouse($event)"
        @mouseleave="$emit('set-highlight', null)"
    ></canvas>
</template>
<script>
import {DailyTime, DefaultSchedule, PeriodicTime, PlayUntilCompleted, PlayUntilTime, Schedule} from '@/api/ScheduleModel'

const dayLength = 25 * 60;
const OFFSET = 0;
const GRIP_WIDTH = 10;
const LANE_HEIGHT = 160;
const CLIP_HEIGHT = 60;
const RULER_MARGIN = 40;
const RULER_FONT = '400 11.5pt "Open Sans", sans-serif';
// const COLOR_FIRST_TASK = '#22a7f0';
//const COLOR_FIRST_TASK = '#000000';
// const COLOUR_SCHEME = [
//     '#444', '#c84', '#cf8', '#8c4', '#8fc', '#4c8', '#8cf', '#48c', '#fc8', '#84c', '#c8f', '#c48', '#f8c'
// ];
// colors
const GRID_COLOR = '#bbbbbb';
const GRID_TEXT_COLOR = '#000';
const CLIP_TEXT_COLOR = '#000';
const CLIP_HIGHLIGHT_COLOR = '#000';

function packSec(s) {
    var h = Math.floor(s / 60);
    var m = s % 60;
    return (h < 10 ? '0' + h : h) + ':' + (m < 10 ? '0' + m : m);
}

export default {
    name: 'ScheduleChart',
    props: {
        schedule: Schedule,
        highlighted: Number,
        files: Array,
        hideContent: Boolean
    },
    data: function(){
        return {
            ctx: null,
            resizeTracker: null,
            addButton: 'null',
            canvasWidth: 0
        }
    },
    mounted: function(){
        this.ctx = this.$refs.chart.getContext('2d');
        setTimeout(this.reflowChart, 100);
        this.resizeTracker = setInterval(() => {
            if(this.ctx.canvas.offsetWidth != this.canvasWidth){
                this.canvasWidth = this.ctx.canvas.width;
                this.reflowChart();
            }
        }, 1000);
        window.addEventListener('resize', this.reflowChart);
        window.addEventListener('click',(e)=>{
          let canvasCoords = e.target.getBoundingClientRect();
          let x = e.clientX - canvasCoords.left;
          let y = e.clientY - canvasCoords.top;
          const buttonDistance = Math.sqrt(
              (x-this.addButton.x) * (x-this.addButton.x)+
              (y-this.addButton.y) * (y-this.addButton.y)
          )
          console.log('btn', buttonDistance)
          if(buttonDistance<this.addButton.radius){
            this.$emit('open-task-modal')
          }
        })
    },
    unmounted: function(){
        window.removeEventListener('resize', this.reflowChart);
        clearInterval(this.resizeTracker);
    },
    computed: {
        clips: function() {
            return this.schedule.tasks.map((task,index) => {
                let start = 0;
                let end = 0;
                let repeat = null;
                let duration = null;
                let type = "daily";
                if(task.schedule instanceof DefaultSchedule){
                    start = 0;
                    end = dayLength;
                    type="default"
                } else if(task.schedule instanceof PlayUntilTime){
                    start = (task.schedule.start instanceof DailyTime) ? (task.schedule.start.hour * 60 + task.schedule.start.minutes) : task.schedule.start.minutes;
                    end = (task.schedule.end instanceof DailyTime) ? (task.schedule.end.hour * 60 + task.schedule.end.minutes) : task.schedule.end.minutes;
                }
                else if(task.schedule instanceof PeriodicTime) {
                        repeat = task.schedule.repeat;
                        start = task.schedule.start.hour * 60 + task.schedule.start.minutes;
                        duration = (task.schedule.duration == 0) ? Math.floor(task.calculateDuration(this.files) / 60) : task.schedule.duration;
                        switch(task.schedule.repeat){
                        case 60:{
                            type = 'hourly';
                            repeat = 60;
                            break;
                        }
                        case 30:{
                            type = 'halfHourly'
                            repeat = 30;
                            break;
                        }
                        case 15:{
                            type = 'quarterHourly'
                            repeat = 15;
                            break;
                        }
                        case 10:{
                            type = 'sixthPartHourtlyTime'
                            repeat = 10;
                            break;
                        }
                        case 5:{
                            type = 'twelfthPartHourtlyTime'
                            repeat = 5;
                            break;
                        }
                    }
                }
                else if(task.schedule instanceof PlayUntilCompleted){
                    start = (task.schedule.start instanceof DailyTime) ? (task.schedule.start.hour * 60 + task.schedule.start.minutes) : task.schedule.start.minutes;
                    end = start + Math.floor(task.calculateDuration(this.files) / 60);
                }

                let color = task.color;
                //let color = COLOUR_SCHEME[task.key % COLOUR_SCHEME.length];
                return { start, end, repeat, duration, task, type,color }
            });
        },
    },
    watch: {
        clips: function(){
            this.reflowChart();
        },
        highlighted: function(){
            this.renderTasks();
        }
    },
    methods: {
        trackMouse: function(e) {
            let canvasCoords = e.target.getBoundingClientRect();
            let x = e.clientX - canvasCoords.left;
            let y = e.clientY - canvasCoords.top;
            let highlighValue = Math.floor((y ) / LANE_HEIGHT)
            this.setHighlight(highlighValue);

        },
        setHighlight: function(index){
            if(index != this.highlighted) {
                this.$emit('set-highlight', index);
            }
        },
        clickAddTask:function(){

        },
        toPixels(min) {
            return (min / dayLength) * this.$refs.chart.width;
        },
        toSeconds(px) {
            return (px / this.$refs.chart.width) * dayLength;
        },
        reflowChart(){
            let chartHeight = (this.clips.length + 1) * LANE_HEIGHT + RULER_MARGIN;
            let rect = this.$refs.chart.parentNode.getBoundingClientRect();
            console.log('rect', rect.width)
            this.$refs.chart.width = rect.width;
            console.log('chart width', this.$refs.chart.width);
            console.log('window width', window.innerWidth);
            if(window.innerWidth < 768){
                this.$emit('update:modelValue', true)
            }else{
                this.$emit('update:modelValue', false)
            }
            this.$refs.chart.height = chartHeight;
            this.$refs.chart.style.height = chartHeight + 'px';
            this.renderTasks();
        },
        drawClip(row, startTime, endTime, isSelected, color, text, isRounded = true) {
            let w = this.ctx.canvas.width;
            let bx = Math.floor(w * startTime / dayLength);
            let by = Math.floor(RULER_MARGIN + row * LANE_HEIGHT + Math.floor((LANE_HEIGHT - CLIP_HEIGHT) / 2));
            let bw = Math.floor(w * Math.max(1, endTime - startTime) / dayLength);
            let bh = CLIP_HEIGHT;
            this.ctx.beginPath()
            this.ctx.fillStyle = color;
            if(isRounded) {
                this.ctx.roundRect(
                    bx + 1, by + 1, bw + 1, bh - 2,10);
            } else {
                this.ctx.fillRect(
                    bx + 1, by + 1, bw + 1, bh - 2,10);
            }
            this.ctx.fill()
            text.forEach((line, index) => {
                this.ctx.fillText(line, bx + 5, by + 5 + 15 * index);
            });
            if(isSelected) {
                this.ctx.strokeStyle = CLIP_HIGHLIGHT_COLOR;
                this.ctx.lineWidth = 2;
                this.ctx.stroke()
                // this.ctx.strokeRect(bx + 0.5, by + 0.5, bw - 1, bh - 1);

            }
        },
        drawRuler() {
            const w = this.ctx.canvas.width;
            this.ctx.font = RULER_FONT;
            this.ctx.textBaseline = 'top';
            // hours
            var chartHeight = this.ctx.canvas.height;
            this.ctx.lineWidth = 1;
            this.ctx.strokeStyle = GRID_COLOR;
            for(var i = 0; i <= dayLength; i+=60) {
                let x = this.toPixels(i);
                this.ctx.beginPath();
                this.ctx.moveTo(x + 0.5, 0);
                this.ctx.lineTo(x + 0.5, chartHeight);
                this.ctx.stroke();
                this.ctx.closePath();
                this.ctx.fillStyle = GRID_TEXT_COLOR;
                this.ctx.fillText((i / 60).toString(), x + 5, 2);
            }
            let new_x = this.toPixels(dayLength+120)
            this.ctx.beginPath();
            this.ctx.moveTo(new_x + 0.5, 0);
            this.ctx.lineTo(new_x + 0.5, chartHeight);
            this.ctx.stroke();
            this.ctx.closePath();
        },
        // drawLaneBorder(num){
        //   const w = this.ctx.canvas.width;
        //   const i = num-1
        //   this.ctx.strokeStyle = GRID_COLOR;
        //   this.ctx.lineWidth = 1;
        //   this.ctx.beginPath();
        //   this.ctx.moveTo(0, RULER_MARGIN + i* LANE_HEIGHT - 0.5);
        //   this.ctx.lineTo(w, RULER_MARGIN +  i*LANE_HEIGHT - 0.5);
        //   this.ctx.stroke();
        //   this.ctx.closePath();
        // },

        drawLaneBorders(num) {
            const w = this.ctx.canvas.width;
            for(let i = 0; i < num; i++) {
                this.ctx.strokeStyle = GRID_COLOR;
                this.ctx.lineWidth = 1;
                this.ctx.beginPath();
                this.ctx.moveTo(0, RULER_MARGIN + i * LANE_HEIGHT - 0.5);
                this.ctx.lineTo(w, RULER_MARGIN + i * LANE_HEIGHT - 0.5);
                this.ctx.stroke();
                this.ctx.closePath();
            }
        },
        drawAddButton(num){
          var w = this.ctx.canvas.width;
          var image = new Image();
          image.src=require('@/assets/rounded_add.svg')
          image.setAttribute('add-button', 'button')
          image.width=39
          image.height=39
          this.ctx.drawImage(image,w/2,RULER_MARGIN/2+num*LANE_HEIGHT)
          this.addButton = {x:w/2,y:RULER_MARGIN/2+num*LANE_HEIGHT,radius:36}

          // this.ctx.canvas.onload = ()=>{
          // }
          // var circle = new Path2D()
          // this.ctx.strokeStyle = GRID_COLOR;
          // circle.moveTo(300, LANE_HEIGHT*2.5);
          // circle.arc(300, LANE_HEIGHT*2.5, 20, 0, 2 * Math.PI);
          // this.ctx.fill(circle)
        },
        renderTasks() {
            var w = this.ctx.canvas.width;
            this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
            this.drawRuler();
            this.drawAddButton(this.clips.length)
          //this.drawLaneBorder(this.clips.length + 2); // NOTE: total + bottom border
            // clips
            for (var i = 0; i < this.clips.length; i++) {
                this.ctx.fillStyle = this.clips.color;
                let startAt = this.clips[i].start;
                let endAt = this.clips[i].end;
                let period = this.clips[i].repeat;
                let duration = this.clips[i].duration;
                let color = this.clips[i].color;
                let isHighlighted = this.highlighted == i;

                if(period != null){
                    for(let offset = startAt; offset <= dayLength + this.toSeconds(OFFSET); offset += period) {
                        let gripWidth = GRIP_WIDTH;
                        
                        this.drawClip(
                            i,
                            offset,
                            duration + offset,
                            //(endAt >= startAt) ? endAt + offset : (endAt + period + offset),
                            isHighlighted,
                            color,
                            []
                        )
                        // do not render grips for now
                        /*
                        this.ctx.fillStyle = '#fff4';
                        this.ctx.fillRect(bx, by, gripWidth, bh);
                        this.ctx.fillRect(bx + bw - gripWidth, by, gripWidth, bh);
                        */
                    }
                } else {
                    var gripWidth = GRIP_WIDTH;
                    if((endAt - startAt) >= 0) {
                        this.drawClip(i, startAt, endAt, isHighlighted, color, []);
                    } else {
                        this.drawClip(i, startAt, dayLength, isHighlighted, color, []);
                        this.drawClip(i, 0, endAt, isHighlighted, color, []);
                    }
                    // do not render grips for now
                    /*
                    this.ctx.fillStyle = '#fff4';
                    this.ctx.fillRect(bx, by, gripWidth, bh);
                    this.ctx.fillRect(bx + bw - gripWidth, by, gripWidth, bh);
                    */
                    
                }
            }

            /** Combined schedule timeline */
            this.clips.forEach((clip) => {
                if((clip.type == 'default') || (clip.type == 'daily')) {
                    if(clip.start > clip.end) {
                        this.drawClip(
                            this.clips.length,
                            0,
                            clip.end,
                            false,
                            clip.color,
                            [],
                            false
                        );
                        this.drawClip(
                            this.clips.length,
                            clip.start,
                            dayLength,
                            false,
                            clip.color,
                            [],
                            false
                        );
                    } else {
                        this.drawClip(
                            this.clips.length,
                            clip.start,
                            clip.end,
                            false,
                            clip.color,
                            [],
                            false
                        );
                    }
                } else {
                    let clipDuration = (clip.end < clip.start) ? (clip.repeat + clip.end - clip.start) : (clip.end - clip.start);
                    if(clip.duration){
                        clipDuration = clip.duration;
                    }

                    for(let offset = (clip.end < clip.start) ? clip.start - clip.repeat : clip.start; offset < dayLength; offset += clip.repeat) {
                        this.drawClip(
                            this.clips.length,
                            offset,
                            offset + clipDuration,
                            false,
                            clip.color,
                            [],
                            false
                        );
                    }
                }
            });
        }
    }
}
</script>
<style scoped>
canvas {
    width: 100%;
    border-right:1px solid #bbbbbb;
    border-bottom:1px solid #bbbbbb;
}
</style>